import { connect } from 'react-redux'
import { Route } from 'react-router'
import React, { useEffect } from 'react'
import UserManager from '../utils/userManager'

const ProtectedRoute: React.FC<any> = ({ component: Component, ...props }) => {
  const { user } = props

  useEffect(() => {
    if (!user || user.expired) {
      UserManager.signinRedirect({ state: window.location.pathname })
    }
  }, [user])

  return (
    <Route {...props}>
      <Component {...props} />
    </Route>
  )
}

function mapStateToProps(state: any) {
  return {
    user: state.oidc.user,
  }
}

export default connect(mapStateToProps)(ProtectedRoute)
